export type UiLang = "oz" | "uz" | "ru";
export type ContentLang = "uz" | "ru" | "en";

export function mapLang(l: UiLang): ContentLang {
  if (l === "oz") return "uz";
  if (l === "uz") return "en";
  return "ru";
}
